import Qualifications from '@/views/employee/Qualifications';
import Skills from '@/views/employee/Skills';
import Experience from '@/views/employee/Experience';
import Certificates from '@/views/employee/Certificates';

export default [
  {
    path: '/qualifications',
    name: 'qualifications',
    component: Qualifications,
  },
  {
    path: '/skills',
    name: 'skills',
    component: Skills,

    meta: { onlyEmployee: false },
  },
  {
    path: '/experience',
    name: 'experience',
    component: Experience,
  },
  {
    path: '/certificates',
    name: 'certificates',
    component: Certificates,
  },
];
